export const subscriptionFlow = [
  { route: 'create-account', title: 'Create Your Account' },
  { route: 'plan-details', title: 'Choose Your Plan' },
  { route: 'checkout', title: 'Payment Info' },
];
